import { connect } from 'react-redux';
import { toggleDialog } from '../../../../store/control/duck';
import { injectIntl } from 'react-intl';
import React, { Fragment } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import Receipt from 'lucide-react/dist/esm/icons/receipt';

const ButtonStyle = {
  padding: 3,
  lineHeight: 1,
  minWidth: 71,
  textTransform: 'unset'
};

const IconWrapperStyle = {
  margin: '4px 0'
};

const ExpenseCalculatorButton = props => {
  const { intl, style, clientId, factsheetId, expenses, onSubmit, toggleDialog } = props;

  const openDialog = () => {
    toggleDialog('expenseCalculator', {
      clientId: clientId,
      factsheetId: factsheetId,
      expenses: expenses,
      onSubmit: onSubmit
    });
  };

  return (
    <Button color="primary" onClick={openDialog} disabled={!clientId} style={{ ...ButtonStyle, ...style }}>
      <Grid container sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <Grid style={IconWrapperStyle}>
          <Receipt size={24} color={clientId ? 'var(--new-theme)' : '#bdbdbd'} />
        </Grid>
        <Grid>
          <Typography align="center" color="textSecondary">
            {intl.formatMessage({ id: 'fin-py-expense-cal' })}
          </Typography>
        </Grid>
      </Grid>
    </Button>
  );
};

const container = connect(state => ({}), {
  toggleDialog
})(ExpenseCalculatorButton);

export default injectIntl(container);
